import { createSlice } from "@reduxjs/toolkit";

const showmoreStatusCodeSlice = createSlice({
    name: "showmoreStatusCode",
    initialState: {
        showmoreStatusCode: null,
    },
    reducers: {
        setShowmoreStatusCode: (state, action) => {
            state.showmoreStatusCode = action.payload;
        },
        clearShowmoreStatusCode: (state) => {
            state.showmoreStatusCode = null;
        },
    },
});

export const { setShowmoreStatusCode , clearShowmoreStatusCode } = showmoreStatusCodeSlice.actions;
export default showmoreStatusCodeSlice.reducer;
